import { useMemo } from "react";
import useModule from "./useModule";
import { Module } from "../types/TenantInterfaces";

interface Props {
  module?: Module | null;
  moduleAPIName?: string;
}

// Hook that returns a modules ImageField + that fields presentation mode
const useRecordImage = ({ module, moduleAPIName }: Props) => {
  const { module: foundModule } = useModule(moduleAPIName);

  const finalModule = module || foundModule;
  const imageField =
    finalModule?.Templates?.RecordDetailView?.ImageField ?? null;

  const imageFieldPresentation = useMemo(() => {
    if (!imageField || !finalModule?.Fields) return null;

    const foundField = finalModule?.Fields.find(
      (field) => field?.APIName === imageField
    );

    return foundField?.Presentation ?? null;
  }, [finalModule?.Fields, imageField]);

  return { imageField, imageFieldPresentation };
};

export default useRecordImage;
